import React, { useEffect } from 'react';
import './ConfirmModal.css';

export default function ConfirmModal({ open, title, message, confirmLabel = 'Подтвердить', cancelLabel = 'Отмена', danger = false, onConfirm, onCancel }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="cm-overlay" onMouseDown={onCancel}>
      <div className="cm-modal" onMouseDown={(e) => e.stopPropagation()}>
        {title && <div className="cm-title">{title}</div>}
        {message && <div className="cm-message">{message}</div>}
        <div className="cm-actions">
          <button type="button" className="cm-btn cm-btn--cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className={`cm-btn ${danger ? 'cm-btn--danger' : 'cm-btn--confirm'}`} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
